import React from 'react'
import { useUiFromSpecContext } from '../../EditorContextProvider'
import { ElementActions } from '../dndElements'
import { Button } from 'alurkerja-ui'
import { BsSave, BsTrash, BsXSquare } from 'react-icons/bs'
import { UseFormReturn } from 'react-hook-form'

export default function EditActions(props: {
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
  form: UseFormReturn<any>
}) {
  const { currentElementState, form } = props
  const {
    removeElementFromSpec,
    setShow,
    selectedPath,
    setSelectedPath,
    updateElementInSpec,
    selectedElement,
    disableSaveEdit,
  } = useUiFromSpecContext()
  const {
    delete: deleteAction = true,
    discard = true,
    save = true,
  } = (currentElementState?.element_actions as ElementActions) || {}

  return (
    <div className="p-4 px-2 flex flex-row space-x-2 w-full justify-center items-center">
      {deleteAction && (
        <Button
          className="text-xs"
          type="button"
          size="small"
          color="danger"
          icon={<BsTrash size={16} />}
          onClick={() => {
            removeElementFromSpec && removeElementFromSpec(selectedPath.split('.'))
            setShow && setShow(false)
            setSelectedPath && setSelectedPath('')
            if (selectedElement?.name) {
              form.unregister(currentElementState?.name)
            }
          }}
        >
          Delete Element
        </Button>
      )}
      {discard && (
        <Button
          className="text-xs"
          type="button"
          size="small"
          color="light-danger"
          icon={<BsXSquare size={16} />}
          onClick={() => {
            setShow && setShow(false)
            setSelectedPath && setSelectedPath('')
          }}
        >
          Discard Changes
        </Button>
      )}
      {save && (
        <Button
          className="text-xs"
          type="button"
          size="small"
          color="primary"
          icon={<BsSave size={16} />}
          disabled={disableSaveEdit}
          onClick={() => {
            setShow && setShow(false)
            updateElementInSpec && updateElementInSpec(selectedPath.split('.'), currentElementState)
            setSelectedPath && setSelectedPath('')
            if (
              selectedElement?.name &&
              currentElementState?.name &&
              selectedElement?.name !== currentElementState?.name
            ) {
              form.unregister(selectedElement?.name)
            }
          }}
        >
          Save Changes
        </Button>
      )}
    </div>
  )
}
